import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import RoleListCell from "./CustomCells/RoleList";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import RoleCellRenderer from "../UserManagement/RoleCellRenderer";
import UserCellRenderer from "../UserManagement/DeleteUserModal/UserCellRenderer";
import DeviceCellRenderer from "./CustomCells/DeviceCellRenderer";
import TruckCellRenderer from "./CustomCells/TruckCellRenderer";
import TagSchemeCellRenderer from "./CustomCells/TagSchemeCellRenderer";

export interface TableComponentProps {
  data?: any;
  searchVal?: string;
  openModal?: Function;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, openModal }) => {

  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [allRows, setAllRows] = useState<any>([]);
  const [original, setOriginal] = useState<any>([]);


  // // filters table for when user types in search value
  // useEffect(() => {
  //   if (searchVal && searchVal !== "") {
  //       let daraRows = [...allRows];
  //     let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
  //     setRows(newRows);
  //   } else {
  //     setRows(original);
  //   }
  // }, [searchVal]);

  // grabs data and sets columns and rows for mui data grid
  useEffect(() => {
    if (data && data.length > 0) {
      let flatData = data.map((item: any) => ({ ...item.data, ...item }));
      //console.log(flatData);
      if (flatData.metadata) {
        flatData = flatData.map((item: any) => ({ ...item.metadata, ...item }));
      }
      let keys = Object.keys(flatData[0]);

      let newRows = [];
      let newKeys = [];

      // rows
      for (let z = 0; z < flatData.length; z++) {
        let newRow = {
          ...flatData[z],
        }
        newRows.push(newRow);
      }

      // columns
      for (let i = 0; i < keys.length; i++) {
        let obj: any = {
          field: keys[i],
          resize:true,
          sortable: true
        }
        if(keys[i] === "roleName") {
          let temp = keys[0];
          //newKeys[0] = {field: "roleName"};
          //obj = { field: temp };
        }
        if(keys[i] === "deviceId") {
          obj = { headerName: 'Device ID', field: keys[i]}
        }
        if(keys[i] === "deviceTypeName") {
          obj = { headerName: 'Device Type', field: keys[i]}
        }
        if(keys[i] === "deviceStatus") {
          obj = { headerName: 'Device Status', field: keys[i]}
        }
        if(keys[i] === "observation1Description") {
          obj = { headerName: 'Observation 1 Description', field: keys[i]}
        }
        if(keys[i] === "observation2Description") {
          obj = { headerName: 'Observation 2 Description', field: keys[i]}
        }
          if(keys[i] === "observation3Description") {
              obj = { headerName: 'Observation 3 Description', field: keys[i]}
          }
        if(keys[i] === "truckName") {
          obj = { headerName: 'Truck Name', field: keys[i]}
        }

        if(keys[i] === "segmentName") {
          obj = { headerName: 'Segment Name', field: keys[i]}
        }

        if(keys[i] === "creationDate") {
          obj = { headerName: 'Creation Date', field: keys[i]}
        }

          if (keys[i] === "roleName") {
              obj = {field: keys[i], minWidth: 200,
                    resizable:true,
                  cellRendererSelector: (params: any) => {
                      return { component: RoleCellRenderer }},
                  cellRendererParams: openModal ?
                      {
                          deleteAction: (modal: any, user: any) => openModal(modal, user) ,
                          editAction: (modal: any, user: any) => openModal(modal, user)
                      } :
                      {}
              }
          }else if (keys[i] === "email") {
              obj = {field: keys[i], minWidth: 200,
                  resizable:true,
                  cellRendererSelector: (params: any) => {
                      return { component: UserCellRenderer }},
                  cellRendererParams: openModal ?
                      {
                          deleteAction: (modal: any, user: any) => openModal(modal, user) ,
                          editAction: (modal: any, user: any) => openModal(modal, user)
                      } :
                      {}
              }
              obj = {field: keys[i], minWidth: 200,
                  resizable:true,
                  cellRendererSelector: (params: any) => {
                      return { component: TagSchemeCellRenderer }},
                  cellRendererParams: openModal ?
                      {
                          deleteAction: (modal: any, user: any) => openModal(modal, user) ,
                          editAction: (modal: any, user: any) => openModal(modal, user)
                      } :
                      {}
              }
          }


        if (keys[i] === "userRoleList") {
          obj = {field: keys[i],
            cellRendererSelector: (params: any) => {
              return { component: RoleListCell } },

          }
        }
        // if (keys.includes("observation1Description") && keys[i] === "truckName") {
        //   obj = {field: keys[i], headerName: 'Truck ID'}
        // }
          if (keys[i] === "serviceProviderNme") {
              obj = {field: keys[i], headerName: 'Service Provider Name',width:230}
          }
        if (keys.includes("warehouseLocationNAme") && keys[i] === "truckName" ) {
          //console.log(keys[i]);
            obj = {field: keys[i], minWidth: 200,
                resizable:true,
                cellRendererSelector: (params: any) => {
                    return { component: TruckCellRenderer }},
                cellRendererParams: openModal ?
                    {
                        deleteAction: (modal: any, user: any) => openModal(modal, user) ,
                        editAction: (modal: any, user: any) => openModal(modal, user)
                    } :
                    {}
            }
        }

        obj.resizable = true;
          if(keys[i] === "email" || (keys[i] === "truckName") && keys.includes("warehouseLocationNAme")) {
              newKeys.unshift(obj);
          }else if(keys[i] === "roleName") {
              newKeys.unshift(obj);
            }else if(keys[i] === "deviceId") {
              newKeys.unshift(obj);
          }
          else if(!(keys[i] === "tagSchemeId" || keys[i] === "truckId" || keys[i] === "active" || keys[i] === "application" || keys[i] === "iotDeviceId" || keys[i] === "lastUpdateDate" || keys[i] === "deviceType" || keys[i] === "lastUpdatedBy" ||  keys[i] === "roleId" || keys[i] === "userId" || keys[i] === "timeZone" || keys[i] === "dateFormat" || keys[i] === "numberFormat" || keys[i] === "sfId")) {
              newKeys.push(obj);
            }
      }

      setColumns(newKeys);
      setRows(newRows);
      setOriginal(newRows);
      setAllRows(newRows);
    }
    else {
      setRows([]);
      setOriginal([]);
      setColumns([]);
      setAllRows([]);
    }
  }, [data]);

  const defaultColDef = {
    sortable: false,
    resizable: true,
    filter: true
  };


  return (
    <Box className="ag-theme-material" sx={{ height: "100%", width: '100%' }}>
      <AgGridReact
        rowData={rows}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={200}
        suppressHorizontalScroll={false}
        rowSelection={"single"}
        rowHeight={40}
        headerHeight={35}
        defaultColDef={defaultColDef}
        enableRangeSelection={true}
      >
      </AgGridReact>
    </Box>
  );
}

export default TableComponent;
